module.exports = __webpack_public_path__ + "static/img/14000808.99ef705f.png";